import { createRequest, getEndpoint } from "../requestCreator";

export const getNumberSequences = createRequest(getEndpoint("numberSequence.sub.get"));
export const deleteNumberSequence = createRequest(getEndpoint("numberSequence.sub.delete"));
export const createNumberSequence = createRequest(getEndpoint("numberSequence.sub.create"));
export const updateNumberSequence = createRequest(getEndpoint("numberSequence.sub.update"), {
  pathCreator: (path, params) => `${path.replace(":id", `${params.id}`)}`,
});
